export default {
  classes: {
    title: "Classes",
  },
  assignments: {
    title: "Assignments",
  },
  students: {
    title: "Students",
  },
  assignment: {
    title: "Assignment",
  },
  student: {
    title: "Student",
  },
  submission: {
    title: "Submission",
  },
  lecture: {
    title: "Lecture",
  },
  eqa: {
    title: "EQA",
  },
  eqaLearner: {
    title: "EQA Learner",
  },
  eqaModule: {
    title: "EQA Module",
  },
  documents: {
    title: "Documents",
  },
  notFound: {
    title: "Page Not Found",
  },
}
